type BadgeColor = 'green' | 'black';
type BadgeSize = 'small' | 'medium' | 'large';

type BadgeProps = {
    text: string;
    size?: BadgeSize;
    color?: BadgeColor;
    top?: string;
    left?: string;
    right?: string;
    bottom?: string;
    width?: string;
    height?: string;
    transform?: string;
};

const backgrounds = {
    black: '#151718',
    green: '#BDF15D',
};

const colors = {
    black: '#BDF15D',
    green: '#151515',
};

const fontSizes = {
    small: '16px',
    medium: '30px',
    large: '40px',
};

const getStyle = (size?: BadgeSize, color?: BadgeColor): React.CSSProperties => {
    return {
        backgroundColor: backgrounds[color || 'black'],
        color: colors[color || 'black'],
        fontSize: fontSizes[size || 'medium'],
        fontFamily: 'Manrope, sans-serif',
        fontWeight: 700,
        display: 'inline-block',
        textAlign: 'center',
        verticalAlign: 'middle',
        letterSpacing: '-0.08%',
        borderRadius: '38px',
    };
};

const Badge: React.FC<BadgeProps> = (props) => {
    const { text, size, color, top, left, right, bottom, width, height, transform } = props;
    const styles = getStyle(size, color);
    return (
        <span style={{ ...styles, position: 'absolute', top, left, right, bottom, width, height, lineHeight: height, transform }}>{text}</span>
    );
};

export default Badge;
